import React, { useState, useEffect, useContext } from "react";
import { getCompanySettings, updateCompanySettings } from "../services/api_settings";
import { AuthContext } from "../contexts/auth";
import Swal from "sweetalert2";

const emailSettingsConfig = [
  { key: "company_email_enabled", label: "Abilita ricezione email" },
  { key: "employee_can_view_previous_shifts", label: "I dipendenti possono visualizzare i turni dei mesi precedenti a quello in corso" },
  { key: "employee_can_view_previous_inouts", label: "I dipendenti possono visualizzare le timbrature dei mesi precedenti a quello in corso" },
];

const CompanyEmailSetting = () => {
  const { token } = useContext(AuthContext);
  const [settings, setSettings] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        setIsLoading(true);
        const fetchedSettings = await getCompanySettings(token, "payrolls");

        const updatedSettings = {};
        emailSettingsConfig.forEach(({ key }) => {
          updatedSettings[key] = fetchedSettings?.[key] ?? false;
        });

        setSettings(updatedSettings);
      } catch (err) {
        console.error("Errore durante il caricamento delle impostazioni.", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSettings();
  }, [token]);

  const handleCheckboxChange = async (key) => {
    const newValue = !settings[key];

    try {
      await updateCompanySettings(token, { [key]: newValue });

      setSettings((prev) => ({
        ...prev,
        [key]: newValue,
      }));

      Swal.fire({
        icon: "success",
        title: "Salvato!",
        showConfirmButton: false,
        timer: 1000,
      });
    } catch (error) {
      console.error("Errore durante il salvataggio:", error);

      let errorMessage = "Non è stato possibile aggiornare l'impostazione. Per favore riprova.";
      if (error.response?.data) {
        const errorData = error.response.data;
        const errorMessages = [];

        Object.entries(errorData).forEach(([_, messages]) => {
          if (Array.isArray(messages)) errorMessages.push(...messages);
          else if (typeof messages === "string") errorMessages.push(messages);
        });

        if (errorMessages.length > 0) errorMessage = errorMessages.join(" ");
      }

      Swal.fire({
        icon: "error",
        title: "Errore",
        text: errorMessage,
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <div className="max-w-full px-4 mx-auto">
      {emailSettingsConfig.map(({ key, label }) => (
        <div key={key} className="flex justify-between items-center py-2 border-b border-gray-200">
          <div className="text-md text-gray-900">
            {label}
            {key == "company_email_contracts_enabled" && (
              <div className="text-gray-500 text-xs mt-1">Invio mail 7 giorni prima della scadenza</div>
            )}
          </div>
  
          <div>
            {isLoading ? (
              "Caricamento..."
            ) : (
              <input
                type="checkbox"
                className="h-5 w-5 rounded text-indigo-600 focus:ring-indigo-600"
                checked={settings[key] || false}
                onChange={() => handleCheckboxChange(key)}
              />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CompanyEmailSetting;
